import request from '@/utils/request'

// 入会申请提交
export function applicationSubmit(params) {
	return request({
		url: '/jeecg-boot/index/applicationSubmit',
		method: 'GET',
		params: params
	})
}

// 意见反馈提交
export function feedbackSubmit(params) {
	return request({
		url: '/jeecg-boot/index/feedbackSubmit',
		method: 'GET',
		params: params
	})
}

// 个人入会申请提交
export function grapplicationSubmit(params) {
	return request({
		url: '/jeecg-boot/index/grapplicationSubmit',
		method: 'GET',
		params: params
	})
}

